
export type GetDashboardSummary200SummaryRecentActivitiesItem = { [key: string]: unknown };
